import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from "@angular/router";
import { AssignedAccountantComponent } from "@app/assigned-accountant/assigned-accountant.component";

@Injectable()
export class CanLogoutClientGuard implements CanDeactivate<AssignedAccountantComponent> {
  canDeactivate(
    component: AssignedAccountantComponent,
    route: ActivatedRouteSnapshot, 
    state: RouterStateSnapshot,
    nextState: RouterStateSnapshot) {
    console.log("route => ", route);
    console.log("state => ", state);
    console.log("nextState => ", nextState);
    if ((nextState.url.indexOf('landing-page') > -1) || nextState.url == '/') {
        return component.canLogout();
    } else {
      return true;
    }
  }
}
